<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.paymentManagement') }}
                    </h3>
                </div>
            </div>

            <div class="pt-3">
                <div class="row">
                    <div class="col-lg-4 col-xl-4" v-if="can">
                        <router-link :to="{ name: 'pay-prestation' }">
                            <stats-card
                                    :title="$tc('message.paymentPrestation', 2)"
                                    type="gradient-teal"
                                    icon="fas fa-money-check-alt"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-4 col-xl-4" v-if="can">
                        <router-link :to="{ name: 'follow-up-souscripteur' }">
                            <stats-card
                                    :title="$tc('message.affiliation', 2)"
                                    type="gradient-orange"
                                    icon="fas fa-money-bill-alt"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-4 col-xl-4" v-if="can">
                        <router-link :to="{ name: 'payment-medicasure' }">
                            <stats-card
                                    :title="$tc('message.paymentMedicasure', 2)"
                                    type="gradient-orange"
                                    icon="fas fa-money-bill-alt"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>
                    <div class="col-lg-4 col-xl-4" v-if="can">
                        <router-link :to="{ name: 'prospect' }">
                            <stats-card
                                    title="Prospects"
                                    type="gradient-orange"
                                    icon="fas fa-users"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "UserManagement",
        computed: {
            ...mapGetters([
                'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },
        },


    }
</script>

<style scoped>

</style>